export enum ScheduleStatus {
  IN_ACTIVE = "IN_ACTIVE",
  ACTIVE = "ACTIVE"
}
